import { render } from "./SummaryReports.vue?vue&type=template&id=36ca8537"
import script from "./SummaryReports.vue?vue&type=script&lang=js"
export * from "./SummaryReports.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__